
import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search, Loader2 } from "lucide-react";
import { UniversalUserCard } from "@/components/common/UniversalUserCard";
import { useFriends } from "@/hooks/useFriends";
import { useTranslation } from "react-i18next";

export const FriendsTab = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const { friends, loading, removeFriend } = useFriends();
  const { t } = useTranslation('friends');

  // Filter friends based on search query
  const filteredFriends = friends.filter(friend => {
    const profile = friend.friend_profile;
    const displayName = [profile.first_name, profile.last_name].filter(Boolean).join(' ') || profile.username;
    return displayName.toLowerCase().includes(searchQuery.toLowerCase()) ||
           profile.username.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <div className="space-y-4">
      {/* Search bar for filtering friends */}
      <div className="relative mb-6">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <Input 
          placeholder={t('friends.search.placeholder')}
          className="pl-10"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="flex justify-center py-8">
          <Loader2 className="h-6 w-6 animate-spin" />
        </div>
      ) : filteredFriends.length === 0 ? (
        <Card className="uplivion-card">
          <CardContent className="p-8 text-center">
            <p className="text-gray-500">
              {searchQuery ? t('friends.search.noResults') : t('friends.search.empty')}
            </p>
          </CardContent>
        </Card>
      ) : (
        filteredFriends.map(friend => (
          <UniversalUserCard 
            key={friend.id} 
            user={friend} 
            variant="friend"
            onRemove={removeFriend}
          />
        ))
      )}
    </div>
  );
};
